import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { RoundingResources } from '../types/RoundingResources';

export const useRoundingTranslation = () => useMessagesTranslation<RoundingResources>();

export type RoundingMessageKey = MessagePaths<RoundingResources>;

export const useRoundingTFunction = () => useRoundingTranslation().t;

export type RoundingTFunction = ReturnType<typeof useRoundingTFunction>;
